<template>
	<div v-if="menuList.length" class="m-menu flex-wrap" :style="{'background': background}">
		<div v-for="(item, i) in menuList" :key="i" class="item flex-column flex-center" :class="[`col${colLength}`]">
			<sub-image class="image" :src="item.img_url" mode="aspectFill" :background="false"></sub-image>
			<p class="ellipsis">{{item.title}}</p>
		</div>
	</div>
	<p v-else class="unit-empty"></p>
</template>

<script>
	export default {
		data() {
			return {
				menuList: [],
				colLength: '',
				background: ''
			}
		},
		
		mounted() {
		},
		
		methods: {
			set(data) {
				this.menuList = data.list;
				this.colLength = data.row_number;
				this.background = data.background;
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-menu {
		padding: 6px 10px;
		
		.item {
			&.col4 {
				width: 25%;
				height: 86px;
				
				&:nth-child(n+9) {
					display: none;
				}
				
				.image {
					width: 62px;
					height: 62px;
				}
			}
			
			&.col5 {
				width: 20%;
				height: 80px;
				
				&:nth-child(n+11) {
					display: none;
				}
				
				.image {
					width: 52px;
					height: 52px;
				}
			}
			
			p {
				box-sizing: border-box;
				width: 100%;
				padding: 0 5px;
				margin-top: 5px;
				line-height: 15px;
				font-size: 13px;
				text-align: center;
				color: #666;
			}
		}
	}
</style>
